<template>
  <div>
    <h6 v-if="profileId == 0" class="heading-small text-muted mb-4">
      Add New Product Group {{ inputName ? " - " + this.inputName : "" }}
    </h6>
    <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Product Group - {{this.inputName}}</h6>
    <h6 v-else class="heading-small text-muted mb-4">
      Edit Product Group - {{ this.inputName }}
    </h6>
    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
        <b-tab title="Details" active v-on:click="openDetails"></b-tab>
        <b-tab title="History" v-on:click="openHistory">
            <b><label>Created By: </label></b>
            {{productGroup.created_by}} | {{productGroup.created_at | dateFilter}} 
            <br>
            <b><label>Updated By:</label></b>
            {{productGroup.updated_by}} | {{productGroup.updated_at | dateFilter}} 
        </b-tab>
    </b-tabs>

    <form id="form-proper">
      <div v-if="customFormMode == 1" v-show="showDetails">
        <!-- Normal -->
        <base-input
          alternative=""
          label="Code"
          placeholder="PG-NAME"
          v-model="productGroup.code"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Name"
          placeholder="Name"
          v-model="productGroup.name"
          input-classes="form-control"
          required
        />
        <base-input alternative="" label="Remark">
          <textarea rows="4" class="form-control" v-model="productGroup.remark" />
        </base-input>

      </div>
      <div v-if="customFormMode == 2">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="productGroup"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Code"
              placeholder="PG-NAME"
              v-model="productGroup.code"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Name"
              placeholder="Name"
              v-model="productGroup.name"
              input-classes="form-control"
              required
            />
            <base-input alternative="" label="Remark">
              <textarea rows="4" class="form-control" v-model="productGroup.remark" />
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="2" forceRender>
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
              }"
              :formSettings="productGroup"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

      <div v-if="this.$attrs.viewMode != true">
        <div
          v-if="serverType == 'ho'"
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-productgroup: #f2f2f2;
            padding: 10px;
          "
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="update"
          >
            Update
          </button>
        </div>
        <div
          v-else
          style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-productgroup: #f2f2f2;
            padding: 10px;
          "
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ValidateField from "../../components/validateFormUtils.js";
import DynamicForm from "../DynamicForm.vue";
import { mapState } from "vuex";
import moment from 'moment'
var component_x;
export default {
  components: {
    DynamicForm,
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function () {
    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Product Group?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }
    component_x = this;
    if (component_x.profileId > 0) {
      var productGroup_data = await HTTPRequest.getRequest(
        component_x.endPoint + "product_groups/" + component_x.profileId,
        null
      );
      if (productGroup_data == undefined) {
        component_x.$router.go();
      } else {
        if (productGroup_data["error"] == undefined) {
          component_x.productGroup = productGroup_data;
          component_x.inputName = productGroup_data["name"];
          component_x.inputCode = productGroup_data["code"];
        } else {
          this.errors = productGroup_data["error"].split(",");
        }
      }
    }

    this.dynamicFormKey++;
  },
  data: function () {
    return {
      inputName: "",
      inputCode: "",
      errors: [],
      showDetails: true,

      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      productGroup: {},
      formErrors: [],
    };
  },
  filters: {
      dateFilter: function (timestamp) {
          return moment(timestamp).format('L LTS')
      }
  },
  methods: {
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.bagger;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;
      if (this.customFormMode == 3) {
        this.errors = errors;
      }
      this.bagger = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
        this.showDetails = true
    },
    openHistory() {
        this.showDetails = false
    },
    validateForm() {
      this.errors = [];
      // this.errors.push(ValidateField.required('Code', this.inputCode));
      // this.errors.push(ValidateField.alphanumericWithSeparator('Code', this.productGroup.code));
      this.errors.push(
        ValidateField.charMinAndMax("Code", this.productGroup.code, 0, 30)
      );
      this.errors.push(ValidateField.required("Name", this.productGroup.name));
      // this.errors.push(ValidateField.alphanumericWithSpace('Name', this.productGroup.name));
      this.errors.push(
        ValidateField.charMinAndMax("Name", this.productGroup.name, 0, 50)
      );
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      return this.errors.length;
    },
    create: async function () {
      if (!this.validateForm()) {
        // var productGroupPayload = {
        //     productGroup: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.productGroup.name = this.productGroup.name.trim();
        if (this.productGroup.code != undefined)
          this.productGroup.code = this.productGroup.code.trim();
        this.productGroup.status = "A";
        var productGroupPayload = { product_group: this.productGroup };

        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "product_groups",
          null,
          productGroupPayload
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(",");
          }
        }
      }
    },
    update: async function () {
      if (!this.validateForm()) {
        // var productGroupPayload = {
        //     productGroup: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.productGroup.name = this.productGroup.name.trim();
        if (this.productGroup.code != undefined)
          this.productGroup.code = this.productGroup.code.trim();
        // this.productGroup.status = "A";
        let status = (this.productGroup.status == null) ?  "A" : this.productGroup.status
        this.productGroup.status = status
        var productGroupPayload = { product_group: this.productGroup };

        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "product_groups/" + this.profileId,
          null,
          productGroupPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(",");
          }
        }
      }
    },
  },
};
</script>

<style>
</style>